module.exports = __webpack_public_path__ + "img/vacaciones-grecia.3d39ce12.jpg";